import { useI18n } from '../../../i18n/useI18n';
import type { ChatbotTrainingExampleWithIdentity } from '../../../types/chatbot';
import { ChatbotTrainingExampleCard } from '../ChatbotTrainingExampleCard';

type ChatbotTrainingExampleListProps = {
  examples: ChatbotTrainingExampleWithIdentity[];
  canManageTraining: boolean;
  savingExampleId: string | undefined;
  deletingExampleId: string | undefined;
  onSave: (
    example: ChatbotTrainingExampleWithIdentity,
    input: { question: string; answer: string; sortOrder: number | null },
    options: { onSuccess: () => void },
  ) => void;
  onDelete: (example: ChatbotTrainingExampleWithIdentity) => void;
};

export function ChatbotTrainingExampleList({
  examples,
  canManageTraining,
  savingExampleId,
  deletingExampleId,
  onSave,
  onDelete,
}: ChatbotTrainingExampleListProps) {
  const { translate } = useI18n();

  return (
    <ul className="chatbot-training__list">
      {examples.map((example) => (
        <li key={example.id}>
          <ChatbotTrainingExampleCard
            example={example}
            questionLabel={translate('chatbots.training.questionLabel')}
            answerLabel={translate('chatbots.training.answerLabel')}
            sortOrderLabel={translate('chatbots.training.sortOrderLabel')}
            sortOrderPlaceholder={translate(
              'chatbots.training.sortOrderPlaceholder',
            )}
            sortOrderHint={translate('chatbots.training.sortOrderHint')}
            editLabel={translate('chatbots.training.edit')}
            deleteLabel={translate('chatbots.training.delete')}
            deleteTitle={translate('chatbots.training.deleteTitle')}
            deleteMessage={translate('chatbots.training.deleteMessage', {
              question: example.question,
            })}
            deleteConfirmLabel={translate('chatbots.training.deleteConfirm')}
            saveLabel={translate('chatbots.training.save')}
            cancelLabel={translate('chatbots.training.cancel')}
            canManage={canManageTraining}
            isSaving={savingExampleId === example.id}
            isDeleting={deletingExampleId === example.id}
            onSave={(input, options) => onSave(example, input, options)}
            onDelete={() => onDelete(example)}
          />
        </li>
      ))}
    </ul>
  );
}
